import React from "react"
import "./Contest.scss"
import { ContestInfo } from "../ContestInfo"
import { ContestTabs } from "../ContestTabs"

export function Contest() {
    return (
        <div className="Contest">
            <ContestInfo />
            <ContestTabs />
        </div>
    )
}
